<template>
  <!-- data-testid: pruebas automáticas (e2e/) -->
  <div
    class="bg-white border-round-3xl cursor-pointer transition-all transition-duration-300 border-2 zapi-card-premium flex flex-column justify-content-start h-full relative overflow-hidden"
    :data-testid="'producto-' + producto.id"
    @click="handleClick"
  >
    <!-- BADGE DE STOCK -->
    <div class="absolute z-5" style="top: -1px; left: 16px;" v-if="stockActual !== null && !producto.requiere_modal && producto.mostrar_stock">
      <ZapiStockBadge 
        :stock-actual="stockActual"
        :stock-minimo="stockMinimo"
        :disponible="disponible"
      />
    </div>

    <!-- BADGE DE COMBO (Original mantenido) -->
    <div class="absolute z-5" style="top: -1px; right: 24px;" v-if="producto.es_paquete">
      <!-- <span class="bg-yellow-500 text-white font-bold px-3 py-2 border-round-bottom-xl text-sm shadow-2">COMBO</span> -->
    </div>

    <!-- IMAGEN (Ajuste de tamaño para no ocupar tanto espacio en tarjetas de laptop) -->
    <div class="pt-4 px-3 mb-2">
      <ZapiProductImage :src="producto.imagen" :alt="producto.nombre" containerHeight="150px" />
    </div>
    
    <!-- Contenedor de información (Padding lateral ajustado) -->
    <div class="px-3 pb-3 flex flex-column flex-1 align-items-start justify-content-start text-left z-1 w-full">
      <!-- Nombre (Tamaño balanceado para no romperse en columnas estrechas) -->
      <span 
        class="text-2xl font-bold text-900 line-height-2 mb-2 w-full" 
        style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; letter-spacing: -0.5px;"
      >
        {{ producto.nombre }}
      </span>

      <!-- Ingredientes (Gris suave, más espaciado) -->
      <span 
        v-if="producto.ingredientes"
        class="text-lg text-500 line-height-3 w-full"
        style="display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;"
        :title="producto.ingredientes"
      >
        {{ producto.ingredientes }}
      </span>
      
      <!-- Precio (Rojo intenso, pegado abajo a la derecha) o Texto de Combo -->
      <div class="flex justify-content-end align-items-end w-full mt-auto">
        <span v-if="producto.es_smart_combo" class="text-2xl font-bold text-green-600 block bg-green-50 px-3 py-1 border-round-xl border-1 border-green-200" style="letter-spacing: -0.5px;">
          <i class="pi pi-box mr-1"></i> Armar Combo
        </span>
        <span v-else class="text-3xl font-bold text-red-600 block" style="letter-spacing: -1px;">
          Bs. {{ producto.precioBase }}
        </span>      
      </div>
    </div>
  </div>
</template>

<script>
import ZapiProductImage from '../atoms/ZapiProductImage.vue';
import ZapiStockBadge from '../atoms/ZapiStockBadge.vue';

export default {
  name: 'ZapiProductCard',
  components: { ZapiProductImage, ZapiStockBadge },
  props: {
    producto: { type: Object, required: true },
    stockActual: {type: Number, default: null},
    stockMinimo: { type: Number, default: 0}
  },
  emits: ['seleccionar'],
  computed: {
    disponible() {
      if(this.stockActual === null) return true;
      return this.stockActual > 0;
    },
    stockBajo() {
      if (this.stockActual === null) return false
      return this.stockActual > 0 && this.stockActual <= this.stockMinimo
    }
  },
  methods: {
    handleClick(){
      //solo emitir evento si el producto esta disponible
      if(this.disponible) {
        this.$emit('seleccionar', this.producto)
      }else{
        // 2026-10: mensajes de stock con nombre. POR QUÉ: «Este producto no está disponible» hacía creer que era un
        // error del sistema; ahora dice cuál producto no tiene stock. Solo cambia el texto: la condición
        // (`disponible`, stockActual > 0) y el evento emitido no cambian. Cubierto por e2e/specs/10-sin-stock-nombre.spec.js.
        // 2026-10 (texto neutro): el aviso orienta al cajero sin afirmar la causa. NO menciona «insumo» a propósito:
        // el POS no sabe por qué el stock es 0 (puede ser un insumo de la receta, el stock directo o el límite de un
        // combo). Si algún día el backend envía `limitado_por` (docs_trabajo/propuesta_mensaje_insumo_faltante.md),
        // este es el único lugar a cambiar. e2e: 10-sin-stock-nombre.spec.js busca este texto exacto.
        this.$toast?.add({
          severity: 'warn',
          summary: 'Sin Stock',
          detail: `El producto "${this.producto.nombre}" no tiene stock disponible. Avise a cocina o almacén.`, // antes: `…no tiene stock` y, antes, 'Este producto no está disponible'
          life: 2000
        })
      }
    }
  }
}
</script>

<style scoped>
/* Sombras Premium de la tarjeta */
.zapi-card-premium {
  border-color: transparent !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04) !important;
}

/* Efecto hover con borde rojo restaurado */
.zapi-card-premium:hover {
  border-color: #e32f3a !important;  
  transform: translateY(-8px); 
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.08) !important;
}

.zapi-card-premium:hover :deep(.zapi-image-transition) {
  transform: scale(1.1) rotate(2deg); /* Efecto más vivo y orgánico */
}

/* Utilidades estéticas */
.zapi-font {
  font-family: 'Impact', 'Arial Black', sans-serif;
  letter-spacing: 0.5px;
}
.zapi-text-gold {
  color: #c98a02;
}
.bg-orange-50 {
  background-color: #fff8f0;
}
</style>